import { autoinject } from 'aurelia-framework';
import Cookies from 'js-cookie';
import { State } from '../services/global-state';
import { Logger } from '../smart/services/logger';

// PostLoginRouteManager helps determine which route to redirect the user to after login/registration based on settings and customer's state
@autoinject
export class PostLoginRouteManager {
	constructor(private globalState: State, private logger: Logger) {

	}

	calculateRoute(postLogingRouteSettings?: IPostLogingRouteSettings ): CalculateRouteResponse {
		try {
			const smsIsOptedIn = 'smsIsOptedIn' in this.globalState.customer.notificationSettings ? this.globalState.customer.notificationSettings.smsIsOptedIn : true;
			const smsIsEnabled = this.globalState.business.portalSettings.businessSettings.enableSMS;
			const requiresSmsValidation = !this.globalState.customer.notificationSettings.smsIsValidated;
			const requiresPrimaryPaymentMethodSetup = !this.globalState.customer.hasPrimaryPaymentMethod;
			const isPayByTextEnabled = this.globalState.hasPayByTextEnabledPortfolio;
			const changePasswordRequired = this.globalState.customer.isTemporaryPassword || postLogingRouteSettings.changePassword;

			if (changePasswordRequired) {
				return new CalculateRouteResponse('changePassword');
			}

			if (this.shouldRedirectToPreferredLanguagePage()) {
				return new CalculateRouteResponse('preferredLanguage');
			}

			// If SMS is not enabled login or they have opted out of sms go to dashboard.
			if (smsIsEnabled && smsIsOptedIn) {
				if (requiresSmsValidation) {
					let routeSettings = {
						phoneNumber: this.globalState.customer.mobilePhone,
						customerId: this.globalState.customer.id,
						redirectTo: 'secure'
					};

					return new CalculateRouteResponse('verification', routeSettings);
				}

				if (isPayByTextEnabled && requiresPrimaryPaymentMethodSetup) {
					return new CalculateRouteResponse('setupPrimaryPaymentMethod');
				}
			}

			return new CalculateRouteResponse('secure');
		}
		catch (error) {
			this.logger.error('PostLoginRouteManager Error: ' + error);
			return new CalculateRouteResponse('secure');
		}
	}

	getMfaCookieName(id: string): string {
		const portalId = this.globalState.business.portalId.split('-').join('');
		return `cp${portalId}${this.globalState.business.key}${id}`;
	}

	getMfaCookie(id: string): string {
		const cookies = this.getCookiesByPrefix(id);
		if (cookies && cookies.length > 0) {
			return Cookies.get(cookies[0]);
		}
		return null;
	}

	getCookiesByPrefix(id: string): string[] {
		const prefix = this.getMfaCookieName(id);
		return document.cookie.split(';').filter((c) =>
			c.trim().indexOf(prefix) === 0
		).map((c) => c.trim().split('=')[0]);
	}

	private shouldRedirectToPreferredLanguagePage(): boolean {
		if (this.globalState.business?.portalSettings?.businessSettings == null ||
			this.globalState.customer == null) {
			return false;
		}

		return this.globalState.business.portalSettings.businessSettings.enablePreferredLanguageAcknowledgement &&
			this.globalState.customer.preferredLanguageSettings.preferredLanguageCode == null &&
			this.globalState.customer.preferredLanguageSettings.declinedToStatePreferredLanguage == null &&
			this.globalState.customer.preferredLanguageSettings.otherPreferredLanguage == null;
	}
}

export class CalculateRouteResponse {
	route: string;
	routeSettings: any;

	constructor(route: string, routeSettings: any = null) {
		this.route = route;
		this.routeSettings = routeSettings;
	}
}

export interface IPostLogingRouteSettings  {
	changePassword: boolean;
}
